import React from 'react'
import { useNotificationsHomeContext } from '../../context'
import { useBreakpoints } from '../../../hooks/useBreakpoints'
import { useConfigPanelStyles } from '../../../hooks/styles/useConfigPanelStyles'
import NotificationCenterFooter from '../NotificationCenterFooter'
import { PanelHeader, PanelBody } from '../ConfigComponents'

export const ConfigPanel = () => {
  const {
    data: {
      notificationCenterPosition,
      notificationCenterOffset,
      showBranding,
      openConfigUnsaved
    }
  } = useNotificationsHomeContext()

  const { smUp, lgUp } = useBreakpoints()
  const {
    getNotificationPanelStyles,
    bodyContainerStyles,
    getBodyWrapperStyles,
    getOverlayStyles,
    keyframesStyles
  } = useConfigPanelStyles()

  return (
    <div
      className='notification-panel'
      style={{
        ...getNotificationPanelStyles({
          lgUp,
          smUp,
          notificationCenterPosition,
          notificationCenterOffset
        }),
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <PanelHeader />

      <div style={{ ...bodyContainerStyles, flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
        <div style={getBodyWrapperStyles(openConfigUnsaved)}>
          <PanelBody />
        </div>
        {openConfigUnsaved && <div style={getOverlayStyles()} />}
      </div>
      <style>{keyframesStyles}</style>

      {showBranding === true ? <NotificationCenterFooter /> : null}
    </div>
  )
}

export default ConfigPanel
